module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAAwCAYAAADZ9HK+AAABBUlEQVR4nO3We0rDQBCA8W9rsFR84IG8UY/jjTyQ+LYm7UqaWVj6l64GfHw/GLZsOi3JzGyb0PfLuQNWwBlwOUaGm/p7ElwBt2M8wnoJw7i/ge4Urj+SBzwAL6Q0tN7DwvL/b54Ac5hOgCVwApxHXMQe06BzB9xHPMceTXlfOAG6H/fw/oYMbIEeeAWO4q6OY30DnuJaH+/Nca01r4kNMI+xKDum3/Uy2dvqeQ9RxE283lWFbM1rYgPMozRAH58+xPSWiS5TPsR62AAteU38DzCHvK9JilgcrFQNUq+lkJ/PS5ZRkiRJkiRJkiRJkiRJkiRJkiRJkiRJkiRJkiRJkiTpdwPeAc1Hai3Ni6IJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/nav_normal1.png
// module id = M34C
// module chunks = 2